import { Component, ElementRef, inject, output, ViewChild } from '@angular/core';
import { HeadshotUploadService } from '../headshot-upload/headshot-upload.service';

@Component({
    selector: 'app-liveness-fb',
    imports: [],
    templateUrl: './liveness-fb.component.html',
    styleUrl: './liveness-fb.component.scss'
})
export class LivenessFbComponent {
  takePhotoCompleted = false
  finalPhoto = ""
  finalPicture = output<string>()

  @ViewChild('video') videoElement!: ElementRef<HTMLVideoElement>;
  headshotService = inject(HeadshotUploadService);
  
  async ngAfterViewInit() {
    this.startWebcam();
  }

  private async startWebcam() {
    const video = this.videoElement.nativeElement;
    if(video){
      const constraints = {
        video: {
          width: { ideal: 640 },
          height: { ideal: 480 },
          facingMode: "user",
        },
      };
      try {
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        video.srcObject = stream;
  
        video.onloadeddata = () => {
          video.play();
        };
      } catch (error) {
        console.error("Error accessing the camera:", error);
      }
    }
  }

  async takePicture(){
    this.finalPhoto = await this.capturePhoto()
    this.takePhotoCompleted = true
  }

  async capturePhoto(): Promise<string> {
    return new Promise((resolve, reject) => {
      try {
        const canvas = document.createElement('canvas');
        const video = this.videoElement.nativeElement;
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const context = canvas.getContext('2d');
        if (context) {
          context.drawImage(video, 0, 0, canvas.width, canvas.height);
        }
        const imageData = canvas.toDataURL('image/jpeg');
        canvas.remove();
        resolve(imageData);
      } catch (error) {
        reject(error);
      }
    });
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  retake(){
    this.takePhotoCompleted = false;
    this.finalPhoto = ""
  }

  submit(){
    this.stopCamera()
    this.finalPicture.emit(this.finalPhoto);
  
  }

  stopCamera() {
    const video = this.videoElement.nativeElement;
    const stream = video.srcObject as MediaStream;
    stream?.getTracks().forEach(track => track.stop());
  }

  back() {
    this.headshotService.showTips = true;
  }
}
